namespace Areas.Dailies {
    "use strict";

    let long;
    let lat;

    export function getWeather() {

        const form = $("#DailiesForm").dxForm("instance");
        const formData = form.option("formData");
        let weatherData = formData.Weather;

        if (weatherData === null) {

            long = form.option("GPSLong");
            lat = form.option("GPSLat");

            const proxy = "https://cors-anywhere.herokuapp.com/";
            const api =
                `${proxy}https://api.darksky.net/forecast/c240b7ac9cccb4d5792139a30969338b/${lat},${long}`;

            fetch(api)
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    const { temperature, summary } = data.currently;
                    weatherData = "Temperature: " + temperature + "  " + summary;
                    formData.Weather = weatherData;
                    form.option("formData", formData);
                });

        }



    }

    export function highLightText() {
        Areas.highLightTextBase("#dailyhtmleditor");
    }
}